import React from 'react';
import cn from 'classnames';

import Channel from 'widget/components/WidgetChannel';
import { IWidgetChannels } from 'widget/entities/config';
import { useAnimatedVisibility } from 'widget/hooks/useAnimatedVisibility';

import styles from './WidgetDesktopChannels.module.scss';

export type WidgetDesktopChannelsProps = {
  channels?: IWidgetChannels;
  isVisible?: boolean;
  className?: string;
};

const WidgetDesktopChannels: React.FC<WidgetDesktopChannelsProps> = ({
  channels,
  isVisible = false,
  className
}) => {
  const { shouldRender, isAnimatedIn } = useAnimatedVisibility(isVisible);

  if (!channels?.length || !shouldRender) {
    return null;
  }

  return (
    <ul
      className={cn(
        styles['channels'],
        isAnimatedIn && styles['channels_visible'],
        className
      )}
    >
      {channels.map((channel) => (
        <li key={channel.kind} className={styles['channels__item']}>
          <Channel channel={channel} withShadow />
        </li>
      ))}
    </ul>
  );
};

export default WidgetDesktopChannels;
